import { useLang } from 'hooks/lang';

import { Alert } from 'components/Blocks';

import {
  FullProjectInvoiceControl,
  ProjectInvoiceControl,
  invoiceControlConfigByCode,
  invoiceControlStatusConfig,
} from 'entities';

interface FullyInvoicedRepriceAlertProps {
  children?: never;
  invoice: ProjectInvoiceControl | FullProjectInvoiceControl | null;
}

export function FullyInvoicedRepriceAlert({
  invoice,
}: FullyInvoicedRepriceAlertProps): JSX.Element | null {
  const { t } = useLang();

  const projectIsAlreadyFullyInvoiced = invoice
    ? invoiceControlConfigByCode[invoice.status].fullValueInvoiced
    : false;

  if (!projectIsAlreadyFullyInvoiced || !invoice) return null;

  return (
    <Alert title={t('project-is-fully-invoiced')} level="warning">
      {t('attention-any-increase-in-price-here-will-change-the-invoice-status-of-this-project', {
        invoiceStatus: invoiceControlConfigByCode[invoice.status].getLabel(t),
        partiallyInvoiced: invoiceControlStatusConfig.partiallyInvoiced.getLabel(t),
      })}
    </Alert>
  );
}
